// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--2IQ43","textBox":"index-module--textBox--2lo3l"};